import {h, Component} from 'preact';
import Page from "../../../services/page-data-feed";
import Config from "../config";

import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { route } from 'preact-router';
import AwrabetPrematchCarousel from '../../awrabet/desktop-components/prematch-carousel.jsx';

export default class PrematchCarousel extends AwrabetPrematchCarousel {
	render() {
		if (this.state.slides == null)
			return null;
		const [emblaRef] = useEmblaCarousel({loop: true}, [Autoplay()])
		
		return (
			<div class="embla" ref={emblaRef}>
				<div class="embla__container">
					{this.state.slides.map(slide => <div class="embla__slide">
						<div class="max-w-full">
							<img src={Config.softionAPI+slide.img} onClick={e => this.maybeOpen(slide)} class="rounded-lg" loading="lazy" />
						</div>
					</div>)}
				</div>
			</div>
		)
	}
}